import React, { useState } from 'react';
import { Container } from "react-bootstrap";
import classes from '../pages.module.css';
import TextCol from "../../components/Ui/text/textCol";
import BtnDownload from '../../components/Ui/button/btnDownload';
import agregator from '../../image/modules/aggregator2.png';
import ModuleItem from '../../components/Ui/block/moduleItem';

const LmRoadm = () => {
    const [texts, settexts] = useState([
        {id:1, content: 'до 40/80 каналов MUX/DEMUX'},
        {id:2, content: 'Ассортимент усилителей EDFA'},
        {id:3, content: 'Полная совместимость с существующим оборудованием'},
        {id:4, content: '2-направленный и многонаправленный ROADMs'},
        {id:5, content: 'Резервирование контроллера и блока питания'},
    ])
    const [lists, setlists] = useState ([
        {id:1, list: 'до 40/80 каналов MUX/DEMUX'},
        {id:2, list: '2-направленный и многонаправленный ROADMs'},
        {id:3, list: 'Ассортимент усилителей EDFA'},
        {id:4, list: 'Резервирование контроллера и блока питания'},
        {id:5, list: 'Конфигурация ILA'},
        {id:6, list: 'Вставные модули OSC'},
        {id:7, list: 'Готов к Flexgrid'},
        {id:8, list: 'Поддержка любых топологий'},
        {id:9, list: 'Автоматическая подстройка мощности'},
        {id:10, list: 'Планировщик Planning tool'},
        {id:11, list: 'Автоматическое гашение лазера APR (Automatic Power Reduction)'},
        {id:12, list: 'Единый сетевой элемент с LM-1 OTN'},
        {id:13, list: 'Поддержка SDN: RESTCONF/Yang в соответствии с моделью ONF'}
    ])
    return (
        <>
            <div className={classes.topBox}>
                <Container fluid="md">
                    <div className={classes.topboxBody}>
                        <span>оборудование для оптических сетей</span>
                        <h1>LM-1 Micro ROADM</h1>
                        <p>Гибкая, компактная система с открытой линейной системой (OLS), ROADM на два направления с полным резервированием в одном юните (1 RU) что позволяет достичь наилучшего показателя компактность/цена/качество для каждого узла.
Данный блок ROADM не имеет матрицы WSS и основан на grid-less оптическом мультиплексоре, что обеспечивает максимальную масштабируемость и поддержку любых лямбд. Также доступен многоступенчатый блок ROADM (на основе WSS). Благодаря стекируемой архитектуре LM-1 microROADM может легко и экономично масштабироваться, удовлетворяя рост оптической сети. LM-1 micro ROADM сочетается с платформой LM-1 WDM, предлагающей также пассивные приложения C\DWDM.</p>
                    </div>
                </Container>
                <div className={classes.topBg_small}></div>
            </div>
            <TextCol texts={texts} />
            <BtnDownload title="Скачать спецификацию" url='/src/download/test.txt' />
            <ModuleItem item={{
                class: 'moduleItem1',
                title: 'LM-1 Micro ROADM',
                src: (agregator),

            }}
                lists={lists}
            />
        </>
    )
}

export default LmRoadm;